class Fetcher<T = any> {

  private path: string;
  private method: string;

  private responseText: string;
  public Result: T | null;

  constructor(path: string, method: string = "GET") {
    this.path = path;
    this.method = method;
    this.responseText = "";
    this.Result = null;
    this.init(path, method);
  }

  public init(path: string, method: string = "GET"): void {
      this.path = path;
      this.method = method;
      // Prepend base url if not explicitly given
      if (!this.path.startsWith("https://") && !this.path.startsWith("http://")) {
          this.path = window.location.origin + "/" + this.path;
      }
      console.log("fetch path: " + path);
  }

  public request(data: string | null = null, callback: ((result: T | null) => void) | null = null): Promise<void> {
    
    let hdrs: { [name: string]: string } = {};
    if(this.method === "POST") {
      hdrs = {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }

    return fetch(this.path, {
        method: this.method,
        headers: hdrs,
        body: data
      })
      .then((response: Response) => response.text())
      .then((text: string) => {
        console.log(text);
        this.responseText = text;
        let result: T | null = null;
        try{
            result = JSON.parse(text);
        } catch(error) {
            alert(error);
            return result;
        }
        return result;
      })
      .then((json: T | null) => {

        this.Result = json;

        return new Promise<string>(
          (resolve, reject) => {
            resolve("uc_fetcher ready!");
            reject("uc_fetcher failed!");
          },
        );
      })
      .then(() => {
        if(callback != null) {
          callback(this.Result);
        }
      })
      .catch((error: any) => {
        if(typeof error != 'object') {
            console.log(error);
            console.log(this.responseText);
        }
        console.error("Error loading JSON:", error.response);
        alert("Error loading JSON: " + error.response);
        error.response.text().then((text: string) => {
            console.log('Response Text:', text);
          }).catch((textError: string) => {
            console.error('Error getting response text:', textError);
          });
      });
  }
}

export default Fetcher;
